// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modalContainer___4T-QQ{width:464px}.formContainer___3hZog{font-size:14px;margin-top:20px}\n", "",{"version":3,"sources":["webpack://./src/components/MerchantOverviewModal/EditModal/EditModal.css"],"names":[],"mappings":"AAAA,wBACI,WAAA,CAGJ,uBACI,cAAA,CACA,eAAA","sourcesContent":[".modalContainer {\n    width: 464px;\n}\n\n.formContainer {\n    font-size: 14px;\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": "modalContainer___4T-QQ",
	"formContainer": "formContainer___3hZog"
};
export default ___CSS_LOADER_EXPORT___;
